import React from 'react'

import { Link } from 'gatsby'

const Tarjeta = ({imagen, english}) => {

    return (
        <div className="tarjeta">
                <div>
                    <img 
                        alt={imagen.titulo} 
                        src={imagen.imagen} 
                        className="contenedor-imagen" 
                    />
                </div>
                <div className="contenido-tarjeta">
                    <div className="tarjeta-info">
                        <h3 className="nombre-proyecto">{imagen.titulo}</h3>
                        <p className="tarjeta-descripcion">{imagen.descripcion}</p>
                    </div>
                    
                    <Link href={imagen.enlace}>
                        <button className="btn btn-claro mas-info">
                            {english ? 'more information' : 'Más información'}
                        </button>
                    </Link>
                </div>
        </div>
    )
}

export default Tarjeta